document.addEventListener('click', function(e) {
  var btn = e.target.closest('.addon-more-info-btn');
  if (!btn) return;

  var data;
  try {
    data = JSON.parse(btn.dataset.addon);
  } catch(err) {
    return;
  }

  var content =
    '<div class="addon-modal-inner">' +
      '<div class="addon-modal-image">' +
        '<img src="' + data.image + '" alt="' + data.title.replace(/"/g, '&quot;') + '" loading="lazy">' +
      '</div>' +
      '<div class="addon-modal-details">' +
        '<h2 class="addon-modal-title heading-font">' + data.title + '</h2>' +
        '<p class="addon-modal-description">' + data.description + '</p>' +
        '<p class="addon-modal-price">' + data.price + '</p>' +
        '<a href="' + data.url + '" class="btn addon-modal-link">View Full Details</a>' +
      '</div>' +
    '</div>';

  $s.openModal(content, 'addon-info-modal');
});
